<template> </template>
<script type="text/javascript">
const serverPath = 'https://service.postmusic.cn/api/';
// const serverPath = "https://service.postmusic.cn/api/tob/";
export default {
  serverPath
};
</script>



// WEBPACK FOOTER //
// src/components/publicLink/publicLink.vue